import Head from "next/head";

import { GLOSSARY_ALPHABET as alphabet } from "constants/glossary";
import useDomain from "hooks/useDomain";

const GlossaryHead = ({ currentLetter = "a" }: { currentLetter: string }) => {
  const domain = useDomain();
  const url = `${domain}/learn/cannabis-glossary?letter=`;

  const currentLetterPosition = alphabet.indexOf(currentLetter);

  return (
    <Head>
      {currentLetterPosition > 0 && (
        <link
          rel="prev"
          href={`${url}${alphabet[currentLetterPosition - 1]}`}
        />
      )}
      {currentLetterPosition < alphabet.length - 1 && (
        <link
          rel="next"
          href={`${url}${alphabet[currentLetterPosition + 1]}`}
        />
      )}
      <title>{`Cannabis terms starting with ${currentLetter.toUpperCase()} | Leafly`}</title>
    </Head>
  );
};

export default GlossaryHead;
